import React from 'react';
import PropTypes from 'prop-types';

const BtnSubmitAuth = ({ 
  children, 
  loading = false, 
  disabled = false, 
  type = 'submit',
  className = '',
  onClick,
  ...props 
}) => {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`
        w-full
        px-5
        py-2
        text-white
        font-medium
        text-sm
        leading-6
        bg-[#50B553]
        hover:bg-[#4AA642]
        focus:bg-[#50CD54]
        focus:outline-none
        focus:ring-2
        focus:ring-green-300
        focus:ring-offset-2
        active:bg-[#325928]
        disabled:opacity-50
        disabled:cursor-not-allowed
        transition-all
        duration-200
        ease-in-out
        rounded-lg
        ${className}
      `}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <svg 
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24"
          >
            <circle 
              className="opacity-25" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            />
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          Đang xử lý...
        </div>
      ) : (
        children
      )}
    </button>
  );
};

BtnSubmitAuth.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'button', 'reset']),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default BtnSubmitAuth;
